// #region imports and type
import { Box } from '@chakra-ui/react';
import { FilterDropdownProps, UseFilterConfigs } from '../useFilterConfigs';
import FilterConditionDropdown from '../filterAtoms/FilterConditionDropdown';
import {
  BetweenAndDivider,
  FilterDateInput,
  FilterNumberInput,
  FilterTextInput,
} from '../filterAtoms/ConditionFilterInputs';
import {
  isDateInputFilter,
  isDateRangeInputFilter,
  isNumberRangeInputFilter,
  isTextInputFilter,
  isTextlessFilter,
} from '../../../../utils/filter/filterCondition';

interface ConditionFilterProps
  extends Pick<
    UseFilterConfigs,
    | 'condition'
    | 'firstText'
    | 'secondText'
    | 'changeCondition'
    | 'changeValue'
    | 'errors'
  > {}
// #endregion

export default function ConditionFilter({
  condition,
  firstText,
  secondText,
  errors,
  changeCondition,
  changeValue,
}: ConditionFilterProps) {
  const firstTextInputProps = {
    title: 'firstText',
    value: firstText,
    isInvalid: !!errors.firstText,
    changeValue,
  };
  const secondTextInputProps = {
    title: 'secondText',
    value: secondText,
    isInvalid: !!errors.secondText,
    changeValue,
  };

  // #region views
  const numberInputGroup = () => (
    <Box>
      <FilterNumberInput {...firstTextInputProps} />
      <BetweenAndDivider />
      <FilterNumberInput {...secondTextInputProps} />
    </Box>
  );

  const dateInputGroup = () => (
    <Box>
      <FilterDateInput {...firstTextInputProps} />
      <BetweenAndDivider />
      <FilterDateInput {...secondTextInputProps} />
    </Box>
  );

  const renderInputsView = () => {
    if (!condition) return null;

    switch (true) {
      case isTextlessFilter(condition):
        return null;
      case isNumberRangeInputFilter(condition):
        return numberInputGroup();
      case isDateRangeInputFilter(condition):
        return dateInputGroup();
      case isDateInputFilter(condition):
        return <FilterDateInput {...firstTextInputProps} />;
      case isTextInputFilter(condition):
        return <FilterTextInput {...firstTextInputProps} />;
      default:
        return <FilterNumberInput {...firstTextInputProps} />;
    }
  };
  // #endregion

  return (
    <Box>
      <FilterConditionDropdown
        condition={condition}
        changeCondition={changeCondition}
      />

      {renderInputsView()}
    </Box>
  );
}
